// usePlayer.ts

import { ref, onMounted, onUnmounted } from 'vue'

export function usePlayerUI() {
  const fullScreen = ref(false)
  const alignScript = ref(true)
  const newWidth = ref(50) // 初始比例

  let resizing = false
  const body = document.body

  function setCursor(cursorType: string) {
    const vScreen = document.getElementById("video") as HTMLElement
    if (vScreen) {
      vScreen.style.cursor = cursorType
    }
    document.body.style.cursor = cursorType
  }

  function resetCursor() {
    setCursor("default")
    document.body.style.userSelect = "auto"
  }

  function resizeScreen(e: MouseEvent) {
    const vScreen = document.getElementById("video") as HTMLElement
    const subtitle = document.getElementById("subtitle") as HTMLElement

    if (resizing && vScreen && subtitle) {
      e.preventDefault()
      const newWidthValue = Math.max(40, Math.min(80, e.clientX / window.innerWidth * 100))
      newWidth.value = newWidthValue
      vScreen.style.width = `${newWidthValue}vw`
      subtitle.style.width = `${100 - newWidthValue}vw`
      subtitle.style.marginLeft = `${newWidthValue}vw`
    }
  }

  function addEventListeners() {
    console.log('addEventListeners')
    const vScreen = document.getElementById("video") as HTMLElement

    if (!vScreen) return

    vScreen.addEventListener("mousemove", (e) => {
      const isResizingZone = e.clientX >= vScreen.offsetWidth - 10 && e.clientX <= vScreen.offsetWidth + 10
      setCursor(isResizingZone ? "ew-resize" : "default")
      document.body.style.userSelect = isResizingZone ? "none" : "auto"
    })

    vScreen.addEventListener("mousedown", (e) => {
      const isResizingZone = e.clientX >= vScreen.offsetWidth - 10 && e.clientX <= vScreen.offsetWidth + 10
      if (isResizingZone) {
        resizing = true
        setCursor("ew-resize")
      }
    })

    document.addEventListener("mouseup", () => {
      resizing = false
      resetCursor()
    })

    document.addEventListener("mousemove", resizeScreen)
  }

  function full() {
    fullScreen.value = true
    body.classList.add('show')
  }

  function single() {
    fullScreen.value = false
    align(true)
    body.classList.remove('show')
  }

  function align(v: boolean) {
    const vScreen = document.getElementById("video") as HTMLElement
    const subtitle = document.getElementById("subtitle") as HTMLElement
    alignScript.value = !v

    if (!alignScript.value) {
      resetCursor()
      vScreen?.style.removeProperty('width')
      subtitle?.style.removeProperty('width')
      subtitle?.style.removeProperty('margin-left')
    } else {
      vScreen!.style.width = `${newWidth.value}vw`
      subtitle!.style.width = `${100 - newWidth.value}vw`
      subtitle!.style.marginLeft = `${newWidth.value}vw`
    }
  }

  onMounted(() => {
    addEventListeners()
  })

  onUnmounted(() => {
    document.removeEventListener("mousemove", resizeScreen)
    document.removeEventListener("mouseup", resetCursor)
  })

  return {
    fullScreen,
    alignScript,
    newWidth,
    full,
    single,
    align,
    addEventListeners
  }
}
